/*  Local Development
 */
const usersServiceApi = 'https://users.api.suvo-services-dev.com/api/v1/';
const dataServiceApi = 'https://data.api.suvo-bi-develop.com/api/v1/';
const subscriptionServiceApi = 'https://subscriptions.api.suvo-bi-develop.com/api/v1/';
const mediaServiceApi = 'https://media.api.suvo-services-dev.com/api/v1';
const mediaStaticAssets = 'https://suvo-services-dev-media.s3.eu-west-1.amazonaws.com/suvo_bi';
const canEditDashboards = true;
const filtersButtonTour = true;

/*  Exported Environment
 */
export const environment = {
  /** @deprecated Use active tenant's `primaryWebUrl`. */
  publicUrl: 'http://localhost:4200/',

  publicDomain: 'suvo-bi-develop.com',
  shopDomainSuffix: 'shops.suvo-bi-develop.com',
  usersServiceApi,
  dataServiceApi,
  subscriptionServiceApi,
  mediaServiceApi,
  mediaStaticAssets,
  title: 'IRJ BI',
  showRegisterDoBField: false,
  production: false,
  canEditDashboards,
  filtersButtonTour,
  tempTenantConfig: {
    showOrganisationFunctionality: false,
  },
  platformId: 'suvo_bi',
  firebaseAuthDomain: 'suvo-bi-users-dev.firebaseapp.com',
  firebaseApiKey: 'AIzaSyBd26S29cSHejJmKiLPb4vRMonrHjgb8vc',
  useDevSubdomain: false,
};

export const suvoUsersClientLibConfig = {
  usersServiceApi,
  dataServiceApi,
  title: 'IRJ BI',
  showRegisterDoBField: false,
};
